module.exports = __webpack_public_path__ + "app/principal/list-referentials-principal-F_pFuf6W.html";